// @mantine
import { TextInput, UnstyledButton } from '@mantine/core';
import { DateTimePicker, DateValue } from '@mantine/dates';
// icons
import { Calendar } from 'lucide-react';
// utils
import { DATE_FORMAT } from '@/const';
import { validateDate } from '@/components/EditableDateTimePicker/EditableDateTimePicker.utils.ts';
import { setAsTimezoneDateTime } from '@/modules/DateTime/utils';
// assets
import styles from '@/components/EditableDateTimePicker/EditableDateTimePicker.module.css';

interface EditableDateTimePickerProps {
    className?: string;
    label: string;
    placeholder: string;
    onChange: (string?: string) => void;
    value?: string;
}

const MIN_YEAR = 2023;
const MIN_MONTH = 0;
const MIN_DATE = 1;

const EditableDateTimePicker = ({
    className,
    label,
    placeholder,
    onChange,
    value
}: EditableDateTimePickerProps) => {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value_ = event.target.value;
        onChange(value_ || undefined);
    };

    const handlePickerChange = (newDate: DateValue) => {
        if (newDate) {
            const datetime = setAsTimezoneDateTime(newDate).toFormat(
                DATE_FORMAT.FULL_12H
            );
            onChange(datetime);
        }
    };

    const isValid = !value || validateDate(value);
    return (
        <TextInput
            className={className}
            error={!isValid}
            label={label}
            placeholder={placeholder}
            rightSection={
                <>
                    <UnstyledButton className={styles.trigger}>
                        <Calendar />
                    </UnstyledButton>

                    <DateTimePicker
                        clearable
                        className={styles.datePicker}
                        maxDate={new Date()}
                        minDate={new Date(MIN_YEAR, MIN_MONTH, MIN_DATE)}
                        size="xs"
                        timeInputProps={{
                            withSeconds: true
                        }}
                        valueFormat={DATE_FORMAT.FULL_12H}
                        onChange={handlePickerChange}
                    />
                </>
            }
            value={value ?? ''}
            onChange={handleInputChange}
        />
    );
};

export default EditableDateTimePicker;
